export default __webpack_public_path__ + "static/melty-81cc1b6f175eac11024b2bd343a4a0a9.png";